<template>
  <yxt-drawer :title="$t('pc_biz_ote_lbl_addstudent')"
              :visible.sync="isShow"
              size="960px"
              direction="rtl"
              :destroy-on-close="true"
              :before-close="done => done(dialogEdited)">
    <select-exam-user
      :id="id"
      ref="selector"
      v-model="selected"
      :groupSelect="groupSelect"
      :functionCode="functionCode"
      :dataPermissionCode="permissionCode"
      :batchId="batchId"
      :projectId="projectId"
      :taskId="taskId"
      @change="handleChange"
    ></select-exam-user>
    <div slot="footer">
      <!--取 消-->
      <yxt-button plain @click="hide">{{ $t('pc_biz_ote_btn_cancle') }}</yxt-button>
      <!--确 定-->
      <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import SelectExamUser from './SelectExamUser.vue';
export default {
  name: 'UsersSelector',
  components: {
    SelectExamUser
  },
  props: {
    id: {
      type: String
    },
    permissionCode: {
      type: String
    },
    limit: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: () => ['persons', 'userGroup', 'advance', 'import']
    },
    // 是否集团化，支持跨机构选择
    groupSelect: {
      type: Boolean,
      default: false
    },
    // 循环考时的 安排的补考批次ID
    batchId: {
      type: String,
      required: false
    },
    // 支持项目内部添加补考人员
    projectId: {
      type: String,
      default: ''
    },
    // 支持项目多班次人员
    taskId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false,
      dialogEdited: false,
      selected: []
    };
  },
  methods: {
    show(selected = []) {
      this.selected = selected;
      this.dialogEdited = false;
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    handleChange() {
      this.dialogEdited = true;
    },
    confirm() {
      this.$emit('didSelect', this.selected);
      // this.hide();
    }
  }
};
</script>
